<template>
  <div class="mypage-ticket-today-safe-modal-section">
    <div class="mypage-ticket-today-safe-modal-section__block">
      <p class="mypage-ticket-today-safe-modal-section__title">
        {{ $tc('MypagePage.MypageTicketTodayPage.safeModal.title') }}
      </p>

      <div class="mypage-ticket-today-safe-modal-section__alert">
        <p class="mypage-ticket-today-safe-modal-section__alert-message">
          {{ $tc('MypagePage.MypageTicketTodayPage.safeModal.message1') }}
        </p>
        <p class="mypage-ticket-today-safe-modal-section__alert-message">
          {{ $tc('MypagePage.MypageTicketTodayPage.safeModal.message2') }}
        </p>
      </div>

      <ul class="mypage-ticket-today-safe-modal-section__buttons">
        <li class="mypage-ticket-today-safe-modal-section__button">
          <atom-button :linkText="$tc('common.yes')" @onClick="handleSubmitClicked" />
        </li>
        <li class="mypage-ticket-today-safe-modal-section__button">
          <atom-button
            :linkText="$tc('common.no')"
            :colorType="'tertiary'"
            @onClick="handleCloseClicked"
          />
        </li>
      </ul>

      <button
        class="mypage-ticket-today-safe-modal-section__button-close"
        @click="handleCloseClicked"
      >
        <span class="mypage-ticket-today-safe-modal-section__button-close-icon">
          <mypage-ticket-close-icon-parts />
        </span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import AtomButton from '@/components/atoms/AtomButton.vue'
import MypageTicketCloseIconParts from '@/components/MypageTicketTodayPage/MypageTicketTodayPane/parts/MypagetTicketCloseIconParts.vue'

export default defineComponent({
  name: 'MypageTicketTodaySafeModalSection',
  components: { MypageTicketCloseIconParts, AtomButton },
  setup(props, { emit }) {
    const handleSubmitClicked = () => {
      emit('onClickSubmit')
    }

    const handleCloseClicked = () => {
      emit('onClickClose')
    }

    return {
      handleSubmitClicked,
      handleCloseClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.mypage-ticket-today-safe-modal-section {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 8px;
  background-color: $black70;

  &__block {
    position: relative;
    width: 100%;
    max-width: 359px;
    padding: 36px 16px 16px;
    margin: auto;
    background-color: #f7f7f7;
    border-radius: 8px;
  }

  &__title {
    font-size: 17px;
    font-weight: 500;
    color: $gray75;
    letter-spacing: 0.04em;
  }

  &__alert {
    margin-top: 16px;
    font-size: 13px;
    font-weight: 500;
    color: #ff2e00;
    letter-spacing: 0.04em;
    line-height: 1.53;

    &-message {
      + .mypage-ticket-today-safe-modal-section__alert-message {
        margin-top: 1.5em;
      }
    }
  }

  &__buttons {
    margin-top: 36px;
  }

  &__button {
    + .mypage-ticket-today-safe-modal-section__button {
      margin-top: 8px;
    }

    &-close {
      position: absolute;
      top: 4px;
      right: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;

      &-icon {
        width: 24px;
        height: 24px;
        color: $black50;
      }
    }
  }
}
</style>
